module.exports = __webpack_public_path__ + "static/landingbuilder-2-13945d65d577b7db25d20928e6549e81.png";